import type { ListBuilderList } from '../../../types';

/**
 * Stale Renewal (PD-16228) — one of the quality classes the tenant value ledger
 * publishes (scripts/license-management/maintenance/active/tenant-value-ledger.mjs),
 * now a list a reviewer can act on instead of a number in a CLI report.
 *
 * The renewal is already on file at the board while the account still shows the old term, so nothing looks wrong until the day it "expires" and becomes a false block. Republic, 2026-09-17: 368 licences.
 *
 * Backed by the locked `licenseRegistryGap: stale_renewal` filter, which reads the
 * registry's own row through the licence's confirmed link OR through an
 * unconfirmed licence-number suggestion at 90%+ — the same rule as the Not
 * Usable card (PD-16225), because Tier-1 auto-confirm refuses to confirm onto a
 * row that disagrees with the licence on file, so waiting for a link would hide
 * the case entirely.
 *
 * Last sale newest first: the actively-buying account is the one to fix first.
 */
export const staleRenewalList: ListBuilderList = {
	id: 'default-licenses-stale-renewal',
	cacheTTL: 300000,
	name: 'Stale Renewal',
	type: 'default',
	active: true,
	sortOrder: 12,
	filterRules: {
		licenseRegistryGap: {
			defaultValue: [
				{
					id: 'stale_renewal',
					label: 'Stale Renewal (board holds a later term)',
				},
			],
			locked: true,
			hidden: true,
		},
	},
	defaultSortId: 'recent-sale-desc',
	inheritsFrom: 'default-licenses-all',
};
